<template>
    <div class="left-right-wrapper">
        <div class="left">
            <slot name="left"></slot>
        </div>
        <div class="right">
            <div class="floating">
                <slot name="right"></slot>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "LeftRightWrapper"
  }
</script>

<style scoped lang="less">
    .left-right-wrapper {
        display: flex;
        width: 100%;
        .left {
            width: calc(100% - 350pt);
            flex: 1; // this is probably obsolete
            min-width: 160pt;
        }
        .right {
            background: white;
            width: 350pt;
            /*min-width: 350pt;*/
            border-left: 1px solid #F0F0F0;
            margin-left: -2pt;
            .floating {
                position: fixed;
                overflow-y: auto;
                padding-bottom: 20pt;
                top: 85pt;
                bottom: 10pt;
            }
        }
    }

</style>